var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-wrapper"},[_c('PageWrapper',[_c('template',{slot:"main"},[_vm._v(" Product ")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }